import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import AttachFile from '@mui/icons-material/AttachFile';

import { Button } from 'uikit/buttons';

import styles from '../styles/quill.module.scss';

const QuillUploadButton = ({ onClick = () => {}, fileUploadAriaLabel = '' }) => {
  const inputRef = useRef();

  const onButtonClick = (event) => {
    inputRef.current.click(event);
  };

  const onInputChange = (event) => {
    onClick(event);
    inputRef.current.value = null;
  };

  return (
    <div className={styles.uploadWrap}>
      <Button
        className={styles.upload}
        ariaLabel={fileUploadAriaLabel}
        variant="ghost"
        icon={<AttachFile />}
        onClick={onButtonClick}
      />
      <input
        ref={inputRef}
        type="file"
        style={{ display: 'none' }}
        onChange={onInputChange}
        accept="image/jpeg,
          image/png,
          image/gif,
          video/quicktime,
          video/mp4,
          text/csv,
          application/pdf,
          application/vnd.ms-excel,
          application/vnd.openxmlformats-officedocument.presentationml.presentation,
          application/vnd.openxmlformats-officedocument.wordprocessingml.document,
          application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      />
    </div>
  );
};

QuillUploadButton.propTypes = {
  fileUploadAriaLabel: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default QuillUploadButton;
